import { render, staticRenderFns } from "./Prestashop.vue?vue&type=template&id=0295e3e2&scoped=true"
import script from "./Prestashop.vue?vue&type=script&lang=js"
export * from "./Prestashop.vue?vue&type=script&lang=js"
import style0 from "./Prestashop.vue?vue&type=style&index=0&id=0295e3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295e3e2",
  null
  
)

export default component.exports